/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Credit_Exhaustion_WaitInputs */

const en_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No rush -- your credits reset on ${i?.date}`)
};

const de_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich warte -- Credits werden am ${i?.date} zurückgesetzt`)
};

const fr_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`J'attendrai -- les crédits se réinitialisent le ${i?.date}`)
};

const es_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esperaré -- los créditos se restablecen el ${i?.date}`)
};

const it_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aspetterò -- i crediti si reimpostano il ${i?.date}`)
};

const nl_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ik wacht -- credits worden gereset op ${i?.date}`)
};

const pl_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Poczekam -- kredyty odnowią się ${i?.date}`)
};

const fi_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odotan -- krediitit nollautuvat ${i?.date}`)
};

const da_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jeg venter — kreditter nulstilles ${i?.date}`)
};

const sv_credit_exhaustion_wait = /** @type {(inputs: Credit_Exhaustion_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jag väntar -- krediter återställs ${i?.date}`)
};

/**
* | output |
* | --- |
* | "No rush -- your credits reset on {date}" |
*
* @param {Credit_Exhaustion_WaitInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const credit_exhaustion_wait = /** @type {((inputs: Credit_Exhaustion_WaitInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credit_Exhaustion_WaitInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_credit_exhaustion_wait(inputs)
	if (locale === "fr") return fr_credit_exhaustion_wait(inputs)
	if (locale === "es") return es_credit_exhaustion_wait(inputs)
	if (locale === "it") return it_credit_exhaustion_wait(inputs)
	if (locale === "nl") return nl_credit_exhaustion_wait(inputs)
	if (locale === "pl") return pl_credit_exhaustion_wait(inputs)
	if (locale === "fi") return fi_credit_exhaustion_wait(inputs)
	if (locale === "da") return da_credit_exhaustion_wait(inputs)
	if (locale === "sv") return sv_credit_exhaustion_wait(inputs)
	return en_credit_exhaustion_wait(inputs)
});